import { Code, Hint, Label, Select } from '@lokalise/louis';

import type { PluralFormat } from '../../../../types';

type Option = { value: PluralFormat; label: string };

interface PluralFormatInputProps {
    value: PluralFormat;
    options: readonly Option[];
    onChange: (value: PluralFormat) => void;
}

const PluralFormatInput = ({ value, options, onChange }: PluralFormatInputProps) => (
    <Label
        id="PluralFormatInput"
        text={
            <>
                Plural format{' '}
                <Hint placement="right" width={600}>
                    Select format to use for plurals.
                    <br />
                    <br />
                    <strong>JSON String</strong>
                    <br />
                    <Code>
                        {'{'}&quot;one&quot;:&quot;One user online&quot;,&quot;other&quot;:&quot;%s users online&quot;
                        {'}'}
                    </Code>
                    <br />
                    <br />
                    <strong>ICU</strong>
                    <br />
                    <Code>
                        {'{'}index.hero.title, plural, one {'{'}One user online{'}'} other {'{'}&#37;s users online{'}'}
                        {'}'}
                    </Code>
                    <br />
                    <br />
                    <strong>Array</strong>
                    <br />
                    Returns an array (if applicable in the format)
                    <br />
                    <br />
                    <strong>i18next</strong>
                    <br />
                    <Code>
                        {'{'}&quot;key&quot;: &quot;One apple&quot;, &quot;key_plural&quot;: &quot;Many apples&quot;
                        {'}'}
                    </Code>
                    <br />
                    <br />
                    <strong>i18next V4</strong>
                    <br />
                    <Code>
                        {'{'}&quot;key_one&quot;: &quot;One apple&quot;, &quot;key_other&quot;: &quot;Many apples&quot;
                        {'}'}
                    </Code>
                    <br />
                    <br />
                    <strong>Symfony</strong>
                    <br />
                    <Code>One apple|Many apples</Code>
                    <br />
                    <br />
                </Hint>
            </>
        }
    >
        <Select
            aria-labelledby="PluralFormatInput"
            value={options.filter((item) => value === item.value)[0]}
            options={options}
            onChange={(val) => {
                if (val === null) {
                    return;
                }
                onChange(val.value);
            }}
        />
    </Label>
);

export default PluralFormatInput;
